<fal [i]="fileTypeDisplay.icon" [style.opacity]=".5"></fal>{{fileTypeDisplay.displayName}}
